export const API_ERROR_CODES = [
    'BAD_REQUEST',
    'VALIDATION_FAILED',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'RATE_LIMITED',
    'NOT_INSTALLED',
    'ALREADY_INSTALLED',
    'MAINTENANCE',
    /* Signed in, but still on the password somebody else chose. */
    'PASSWORD_CHANGE_REQUIRED',
    /* Joined from the company link, and the company has not said yes yet. */
    'APPROVAL_PENDING',
    'PAYLOAD_TOO_LARGE',
    'INTERNAL',
];
/** Entity buckets used as the middle segment of every storage key. */
export const FILE_ENTITY_TYPES = [
    'menu',
    'recipe',
    'ingredient',
    'notice',
    'avatar',
    'attachment',
];
//# sourceMappingURL=api.js.map